import type { ReactElement } from 'react'
import { useFormContext } from 'react-hook-form'
import { Dropdown } from '~/components/Form'
import {
  optionItemElementLabel,
  optionItemElementLabelMain,
  optionItemElementSublabel
} from '~/components/Form/Input/Dropdown.css'

const visibilityLabel: Record<string, string> = {
  instance: 'Global',
  agency: 'Agence',
  user: 'Personnel'
}

type Template = {
  id: number
  name: string
  content: string
  visibility: string
  agency?: { id: number; name: string } | null
}

type SmsTemplateSelectorProps = {
  templates: Template[]
  agencyId: number | null
  onSelect: (content: string) => void
}

type FormValues = {
  message: string
}

export const SmsTemplateSelector = ({
  templates,
  agencyId,
  onSelect
}: SmsTemplateSelectorProps): ReactElement => {
  const { setValue } = useFormContext<FormValues>()
  const options = templates
    .filter((t) => !t.agency || t.agency.id === agencyId)
    .map((t) => ({
      label: t.name,
      value: String(t.id),
      element: (
        <div className={optionItemElementLabel}>
          <div className={optionItemElementLabelMain}>{t.name}</div>
          <div className={optionItemElementSublabel}>
            {t.visibility === 'agency' && t.agency
              ? t.agency.name
              : (visibilityLabel[t.visibility] ?? t.visibility)}
          </div>
        </div>
      )
    }))
  return (
    <Dropdown
      options={options}
      placeholder="Sélectionner un modèle"
      fullWidth
      searchable
      onChange={(value) => {
        const selected = templates.find((t) => String(t.id) === value)
        if (selected) {
          setValue('message', selected.content, { shouldDirty: true })
          onSelect(selected.content)
        }
      }}
    />
  )
}
